import { NProgressOptions } from "nprogress";

export const progressBarConfig: Partial<NProgressOptions> = {
  showSpinner: false,
  trickle: true,
  trickleSpeed: 200,
  minimum: 0.08,
  easing: "ease",
  speed: 200,
};
